module.exports = __webpack_public_path__ + "static/img/2.6d580d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/2.png
// module id = m6mp
// module chunks = 0